import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

import { ResultsSerch } from '../search/models/results.model';

@Injectable({ providedIn: 'root' })
export class SearchService {
  private http = inject(HttpClient);
  private apiSearch: string;
  private headers = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor() {
    this.apiSearch = environment.apiSearch;
  }

  getAllDictionaries(keywords: string): Observable<ResultsSerch> {
    return this.http.get<ResultsSerch>(
      this.apiSearch + '?keywords__fuzzy=' + keywords,
      this.headers
    );
  }

  getResultsFromInput(keywords: string): Observable<ResultsSerch> {
    return this.http.get<ResultsSerch>(
      this.apiSearch + '?page_size=6&keywords__fuzzy=' + keywords,
      this.headers
    );
  }

  getMoreResults(url: string): Observable<ResultsSerch> {
    return this.http.get<ResultsSerch>(url, this.headers);
  }
}
